import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { scrollToId } from "@/hooks/useLenis";
import { useReserve } from "./Reserve";

const links = [
  { label: "The Philosophy", id: "philosophy" },
  { label: "Find Your Stage", id: "assessment" },
  { label: "The Seven Days", id: "days" },
  { label: "Brian", id: "brian" },
  { label: "FAQ", id: "faq" },
];

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menu, setMenu] = useState(false);
  const { open } = useReserve();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setMenu(false);
    scrollToId(id);
  };

  return (
    <header
      data-testid="site-nav"
      className={`fixed top-0 inset-x-0 z-50 transition-colors duration-500 ${
        scrolled || menu ? "bg-cream/90 backdrop-blur-md border-b border-[var(--line)]" : "bg-transparent"
      }`}
    >
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8 h-16 sm:h-20 flex items-center justify-between gap-4">
        <button
          data-testid="nav-logo"
          onClick={() => go("top")}
          className="font-serif text-ocean text-base sm:text-xl tracking-tight leading-none text-left whitespace-nowrap"
        >
          Your Business Roadmap
          <span className="hidden sm:block text-[10px] font-sans uppercase tracking-[0.28em] text-cognac mt-0.5">
            in 7 days · with Brian Smith
          </span>
        </button>

        <nav className="hidden md:flex items-center gap-9">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-${l.id}`}
              onClick={() => go(l.id)}
              className="link-underline font-sans text-sm text-ocean/80 hover:text-ocean"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <button
            data-testid="nav-cta"
            onClick={() => open("nav")}
            className="font-sans text-[11px] sm:text-sm uppercase tracking-[0.18em] bg-cognac text-cream px-4 sm:px-6 py-2.5 sm:py-3 hover:bg-ocean transition-colors duration-300 whitespace-nowrap"
          >
            <span className="sm:hidden">Reserve</span>
            <span className="hidden sm:inline">Reserve My Spot</span>
          </button>
          <button
            data-testid="nav-menu-toggle"
            onClick={() => setMenu(!menu)}
            aria-label="Menu"
            className="md:hidden flex flex-col justify-center gap-[5px] h-10 w-10 items-center"
          >
            <span className={`block h-px w-5 bg-ocean transition-transform duration-300 ${menu ? "translate-y-[3px] rotate-45" : ""}`} />
            <span className={`block h-px w-5 bg-ocean transition-transform duration-300 ${menu ? "-translate-y-[3px] -rotate-45" : ""}`} />
          </button>
        </div>
      </div>

      <AnimatePresence>
        {menu && (
          <motion.nav
            data-testid="nav-mobile-menu"
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
            className="md:hidden overflow-hidden border-t border-[var(--line)]"
          >
            <div className="px-5 py-4 flex flex-col">
              {links.map((l) => (
                <button
                  key={l.id}
                  data-testid={`nav-mobile-${l.id}`}
                  onClick={() => go(l.id)}
                  className="py-3 text-left font-serif text-xl text-ocean border-b border-[var(--line)] last:border-b-0"
                >
                  {l.label}
                </button>
              ))}
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </header>
  );
};
